export const openSideBar = isOpen => (isOpen ? '250px' : '50px');
